import React, { useState } from "react";
import { searchPayloads } from "../api/payloadService";
import XmlViewerModal from "./XmlViewerModal";

const PAGE_SIZE = 50;

const PAYLOAD_TYPES = [
  "", "BOM", "SOURCELIST", "SUPPLIER", "SUPPLIER_ADDRESS",
  "SUPPLIER_CONTACT", "MATERIAL",
];
const STATUSES = ["", "RECEIVED", "PROCESSING", "COMPLETED"];
const STATUS_CLASS = {
  COMPLETED: "status-OK",
  PROCESSING: "status-PROCESSING",
  RECEIVED: "status-WARN",
};

export default function PayloadsPage() {
  const [filters, setFilters] = useState({
    payloadType: "", materialNumber: "", supplierNumber: "",
    docnum: "", status: "", dateFrom: "", dateTo: "",
  });
  const [page, setPage] = useState(0);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const onChange = (e) => setFilters({ ...filters, [e.target.name]: e.target.value });

  const doSearch = async (targetPage = 0) => {
    setLoading(true);
    setError(null);
    try {
      const params = { size: PAGE_SIZE, page: targetPage };
      Object.entries(filters).forEach(([k, v]) => {
        if (v !== "" && v != null) params[k] = v;
      });
      const data = await searchPayloads(params);
      setResult(data);
      setPage(targetPage);
    } catch {
      setError("Search failed. Your session may have expired — try logging out and back in.");
    } finally {
      setLoading(false);
    }
  };

  const clear = () => {
    setFilters({
      payloadType: "", materialNumber: "", supplierNumber: "",
      docnum: "", status: "", dateFrom: "", dateTo: "",
    });
    setResult(null);
    setPage(0);
    setError(null);
  };

  const startRow = page * PAGE_SIZE + 1;
  const endRow = result ? page * PAGE_SIZE + result.rows.length : 0;

  return (
    <div>
      <div className="card">
        <h2>IDoc Payload Search</h2>
        <div className="payload-filters">
          <select name="payloadType" value={filters.payloadType} onChange={onChange}>
            {PAYLOAD_TYPES.map((t) => (
              <option key={t} value={t}>{t || "All Types"}</option>
            ))}
          </select>
          <input
            name="materialNumber"
            placeholder="Material #"
            value={filters.materialNumber}
            onChange={onChange}
          />
          <input
            name="supplierNumber"
            placeholder="Supplier #"
            value={filters.supplierNumber}
            onChange={onChange}
          />
          <input
            name="docnum"
            placeholder="Docnum"
            value={filters.docnum}
            onChange={onChange}
          />
          <select name="status" value={filters.status} onChange={onChange}>
            {STATUSES.map((s) => (
              <option key={s} value={s}>{s || "All Statuses"}</option>
            ))}
          </select>
          <label className="date-label">
            From
            <input name="dateFrom" type="date" value={filters.dateFrom} onChange={onChange} />
          </label>
          <label className="date-label">
            To
            <input name="dateTo" type="date" value={filters.dateTo} onChange={onChange} />
          </label>
          <button className="btn-primary" onClick={() => doSearch(0)} disabled={loading}>
            {loading ? "Searching…" : "Search"}
          </button>
          <button className="btn-secondary" onClick={clear} disabled={loading}>
            Clear
          </button>
        </div>
      </div>

      {error && <div className="payload-error">{error}</div>}

      {result && (
        <div className="card">
          <div className="payload-result-info">
            {result.rows.length === 0
              ? "No results found."
              : `Showing ${startRow}–${endRow}${result.hasMore ? "+" : ""}`}
          </div>
          <table className="log-table">
            <thead>
              <tr>
                <th>Type</th>
                <th>Material #</th>
                <th>Supplier #</th>
                <th>Plant</th>
                <th>Docnum</th>
                <th>Status</th>
                <th>Received At</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {result.rows.map((row, idx) => (
                <tr key={idx}>
                  <td>{row.payloadType}</td>
                  <td>{row.materialNumber}</td>
                  <td>{row.supplierNumber}</td>
                  <td>{row.plant}</td>
                  <td>{row.docnum}</td>
                  <td>
                    <span className={`status-badge ${STATUS_CLASS[row.processingStatus] || ""}`}>
                      {row.processingStatus}
                    </span>
                  </td>
                  <td>
                    {row.createdAt ? new Date(row.createdAt).toLocaleString() : ""}
                  </td>
                  <td>
                    <button className="btn-inspect" onClick={() => setSelectedRow(row)}>
                      Inspect
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="payload-pagination">
            <button
              onClick={() => doSearch(page - 1)}
              disabled={page === 0 || loading}
            >
              &larr; Prev
            </button>
            <span>Page {page + 1}</span>
            <button
              onClick={() => doSearch(page + 1)}
              disabled={!result.hasMore || loading}
            >
              Next &rarr;
            </button>
          </div>
        </div>
      )}

      {selectedRow && (
        <XmlViewerModal row={selectedRow} onClose={() => setSelectedRow(null)} />
      )}
    </div>
  );
}
